import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCC_ENDPOINTS } from '@availability/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { SHOPS_NORMALIZER } from '@core/utils';
import { OccShopsByProductResponse, ShopsByProduct } from '@shop/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccShopsService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
  ) {}

  loadByProduct(productCode: string, unitCode: string): Observable<ShopsByProduct> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.shopsByProduct, {
      urlParams: { productCode },
      queryParams: { unitCode },
    });

    return this.http
      .get<OccShopsByProductResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.shopsByProduct),
      })
      .pipe(this.converterService.pipeable(SHOPS_NORMALIZER));
  }
}
